import { AppState } from '../types';

export const getConfirmAccountStatus = (state: AppState) => state.account.confirmAccount.status;
export const getConfirmProfileLinkStatus = (state: AppState) => state.account.confirmProfileLink.status;
export const getResetPasswordStatus = (state: AppState) => state.account.resetPassword.status;
export const getResetPasswordError = (state: AppState) => state.account.resetPassword.error;
